// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-len */

import { getLanguage } from '../state'
// Spanish is default value
export const getLanguageId = () => ['en'].indexOf(getLanguage())

export const dictionary = {
  // Header
  'Grupo de proyectos': ['Project group'],
  Prioridad: ['Priority'],
  Pais: ['Country'],
  región: ['region'],
  Priorizado: ['Prioritized'],
  'Agencias de cooperación': ['Cooperation agencies'],
  'Proyectos Priorizados': ['Prioritized Projects'],
  'Proyectos de implementación acelerada': ['Accelerated Implementation Projects'],
  'Proyectos No Priorizados': ['Non-Prioritized Projects'],
  'Todos los proyectos': ['All projects'],
  'Proyectos PDI - Gobiernos (actualización Enero 2022)': ['PDI Projects - Governments (updated January 2022)'],
  'Proyectos Sistema UN': ['UN System Projects'],
  'Sub-región PDI': ['Sub-region PDI'],
  México: ['Mexico'],
  Honduras: ['Honduras'],
  'El Salvador': ['El Salvador'],
  Guatemala: ['Guatemala'],

  // Menu
  'FILTRE INFORMACIÓN SEGÚN DIFERENTES DIMENSIONES': [
    'FILTER INFORMATION ACCORDING TO DIFFERENT DIMENSIONS'
  ],
  'PILARES Y PROGRAMAS DEL PDI': ['PILLARS AND PROGRAMS OF THE PDI'],
  'Todos los pilares': ['All the pillars'],
  'Pilar Desarrollo Económico': ['Economic Development Pillar'],
  'Infraestructura habilitante': ['Enabling infrastructure'],
  'Fomento comercial e integración regional': [
    'Trade promotion and regional integration'
  ],
  'Desarrollo productivo': ['Productive development'],
  'Desarrollo territorial': ['Territorial development'],
  'Macroeconomía para el desarrollo': ['Macroeconomics for development'],
  'Pilar Bienestar Social': ['Social Welfare Pillar'],
  'Inclusión social y laboral': ['Social and labor inclusion'],
  'Habilidades para la vida': ['Life skills'],
  'Desarrollo infantil integral': ['Comprehensive child development'],
  'Salud a lo largo de la vida': ['Health throughout life'],
  'Prevención de violencia y cultura de paz': [
    'Prevention of violence and culture of peace'
  ],
  'Pilar de Respuesta al cambio climático': [
    'Response Pillar to Climate Change'
  ],
  'Generación de conocimiento, datos y herramientas para la adaptación al cambio climático y riesgos de desastres':
    [
      'Generation of knowledge, data and tools for adaptation to climate change and disaster risks'
    ],
  'Fortalecimiento de la resiliencia para prevenir el desplazamiento por desastres':
    ['Strengthening Resilience to Prevent Disaster Displacement'],
  'Cambio climático y soluciones basadas en la naturaleza': [
    'Climate change and nature-based solutions'
  ],
  'Pilar Gestión integral del ciclo migratorio': [
    'Pillar Integral Management of the migratory cycle'
  ],
  'Respuestas integrales nacionales': ['National comprehensive responses'],
  'Acciones regionales': ['Regional actions'],
  'NIVEL TERRITORIAL': ['TERRITORIAL LEVEL'],
  Supranacional: ['Supranational'],
  Nacional: ['National'],
  Subnacional: ['Subnational'],
  ODS: ['ODS'],
  'ODS 1': ['ODS 1'],
  'ODS 2': ['ODS 2'],
  'ODS 3': ['ODS 3'],
  'ODS 4': ['ODS 4'],
  'ODS 5': ['ODS 5'],
  'ODS 6': ['ODS 6'],
  'ODS 7': ['ODS 7'],
  'ODS 8': ['ODS 8'],
  'ODS 9': ['ODS 9'],
  'ODS 10': ['ODS 10'],
  'ODS 11': ['ODS 11'],
  'ODS 12': ['ODS 12'],
  'ODS 13': ['ODS 13'],
  'ODS 14': ['ODS 14'],
  'ODS 15': ['ODS 15'],
  'ODS 16': ['ODS 16'],
  'ODS 17': ['ODS 17'],
  'ENTIDAD IMPLEMENTADORA': ['IMPLEMENTING ENTITY'],
  ACNUR: ['ACNUR'],
  'Banco Mundial': ['World Bank'],
  FAO: ['FAO'],
  FIDA: ['FIDA'],
  ITC: ['ITC'],
  OACNUDH: ['OACNUDH'],
  OCHA: ['OCHA'],
  OIM: ['OIM'],
  OIT: ['OIT'],
  'ONU Habitat': ['ONU Habitat'],
  'ONU Mujeres': ['ONU Women'],
  ONUDI: ['ONUDI'],
  ONUSIDA: ['ONUSIDA'],
  'OPS/OMS': ['OPS/OMS'],
  PMA: ['PMA'],
  PNUD: ['UNDP'],
  PNUMA: ['PNUMA'],
  UNESCO: ['UNESCO'],
  UNFPA: ['UNFPA'],
  UNICEF: ['UNICEF'],
  UNODC: ['UNODC'],
  UNOPS: ['UNOPS'],
  COOPERACIÓN: ['COOPERATION'],
  'AGENCIAS DE COOPERACIÓN': ['COOPERATION AGENCIES'],
  'AGREGUE CAPAS DE INFORMACIÓN ESTADÍSTICA': [
    'ADD LAYERS OF STATISTICAL INFORMATION'
  ],
  'AGREGUE CAPAS GEOGRÁFICAS': ['ADD GEOGRAPHIC LAYERS'],

  // Selected layer
  'Agregar indicadores': ['Add indicators'],
  'Capas Seleccionadas': ['Selected Layers'],
  'Datos geográficos': ['Geographical data'],
  'Agregar capa': ['Add layer'],
  Desde: ['from'],
  Hasta: ['to'],
  'Cambie dimensiones del indicador': ['Change indicator dimensions'],
  'Visualice el indicador en el Dashboard': [
    'View the indicator in the Dashboard'
  ],
  'Mostrar el último dato disponible para cada país': [
    'Show the latest data available for each country'
  ],
  'Personalice su mapa': ['Customize your map'],
  'Incluir nombres': ['Include names'],
  'Incluir valor': ['Include value'],

  // SideBarRight Pilares
  'LISTADO DE PROYECTOS SUB:REGIÓN PDI': ['LIST OF SUB PROJECTS: PDI REGION'],
  'Cantidad de proyectos': ['Number of projects'],
  'Proyectos PDI': ['Projects PDI'],
  'Otros proyectos': ['Other projects'],
  'Proyectos regionales': ['Regional projects'],
  'Proyectos nacionales': ['National projects'],
  'Proyectos subnacionales': ['Subnational projects'],
  PROYECTO: ['PROJECT:'],
  'DIMENSIONES Y PROGRAMAS DEL PDI': ['DIMENSIONS AND PROGRAMS OF THE PDI'],
  OBJETIVO: ['OBJECTIVE'],
  PRIORIDAD: ['PRIORITY'],
  'NIVEL TERRITORIAL': ['TERRITORIAL LEVEL'],
  IMPLEMENTADORA: ['IMPLEMENTER'],
  'OTRAS AGENCIAS': ['OTHER AGENCIES'],
  'SOCIOS IMPLEMENTADORES': ['IMPLEMENTING PARTNERS'],
  'OBJETIVOS DE DESARROLLO SOSTENIBLE': ['SUSTAINABLE DEVELOPMENT GOALS'],
  'TIEMPO DE IMPLEMENTACIÓN': ['IMPLEMENTATION TIME'],
  'Sin fecha de término': ['No end date'],
  'Proyectos seleccionados': ['Selected projects'],
  'AGENCIA LÍDER': ['LEADING AGENCY'],

  // SideBarRight IndicatorDefinition
  'Descripción / Ficha técnica': ['Description / Data sheet'],
  'Acceda a la ficha metodológica': ['Access the methodological file'],

  // SideBarRight IndicatorData
  Datos: ['Data'],
  País: ['Country'],
  Ciudad: ['City'],
  Valor: ['Value'],

  // Others
  '': [''],
  '': [''],
  '': ['']
}

// Get the word in the current language
export const t = (word) => {
  const dict = dictionary[word]
  const id = getLanguageId(getLanguage())
  return dict && id >= 0 ? dict[id] : word
}
